import AnimatedBackground from '../../Components/AnimatedBackground';
import DropBankInfo from './components/DropBankInfo';
import Wallet from './components/Wallet';

function DropBank() {
  return (
    <div>
      <AnimatedBackground backgroundPage="upgradeUnlockLevel" />
      <div
        className="
          absolute
          z-1
          inset-0
          mt-[68px]
        "
      >
        <DropBankInfo />
        <div
          className="
            w-[calc(100%-34px)]
            absolute
            bottom-[84px]
            left-1/2
            -translate-x-1/2
          "
        >
          <Wallet />

        </div>
      </div>
    </div>
  );
}

export default DropBank;
